import Drawer from "./index";
const WithDrawer =
  (WrappedComponent) =>
  ({ open, anchor, variant, BackdropProps, drawerClasses, ...otherProps }) =>
    (
      <Drawer
        open={open}
        anchor={anchor}
        variant={variant}
        BackdropProps={BackdropProps}
        drawerClasses={drawerClasses}
      >
        <WrappedComponent {...otherProps} />
      </Drawer>
    );

export default WithDrawer;
